import React from 'react';
import { withTranslation } from 'react-i18next';
import PasswordField from '../Form/PasswordField';
import Link from '../Helper/Link';
import { FormError } from '../Form/errors';

const ResendActivationMessage = withTranslation()(({ email, resend, t }) => {
  return (
    <>
      {resend.data.success && (
        <h6 className="activation-resend-success">
          <span className="icon-tick" /> {t('A new activation link has been sent to')} <strong>{email}</strong>.{' '}
          {t('Please use it to activate your account.')}
        </h6>
      )}
    </>
  );
});

const ResendActivationError = withTranslation()(({ loginError, email, resend, t }) => {
  if (!loginError || loginError.HTTPStatus !== 403 || loginError.message.indexOf('not active') === -1) {
    return null;
  }

  return (
    <p>
      <span
        id="btn-resend-activation-code"
        className={`link ${resend.data.loading ? 'disabled' : ''}`}
        onClick={() => !resend.data.loading && resend.action(email)}
      >
        {t('Resend activation link')}
      </span>
    </p>
  );
});

export const PasswordForm = withTranslation()(
  ({
    children,
    email,
    password,
    error,
    fieldErrors,
    fieldWarnings,
    resend,
    resendActivationCode,
    buttonsDisabled,
    onInputChange,
    onChangeLoginEmail,
    onSubmitLogin,
    t,
  }) => (
    <form
      id="form-login"
      method="post"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmitLogin();
      }}
    >
      {error && (
        <FormError error={error}>
          <ResendActivationError
            loginError={error}
            email={email}
            resend={{ data: resend, action: resendActivationCode }}
          />
        </FormError>
      )}

      <ResendActivationMessage email={email} resend={{ data: resend, action: resendActivationCode }} />
      <div className="change-login-email-wrapper">
        <span>{email}</span>
        <a className="link" onClick={onChangeLoginEmail}>
          {t('Change')}
        </a>
      </div>
      <PasswordField
        inputName="password"
        value={password}
        label={t('Password')}
        error={fieldErrors.password}
        showHideButton
        disabled={buttonsDisabled}
        warning={fieldWarnings.password}
        onChange={(e) => onInputChange(e.target.id, e.target.value)}
      >
        <Link id="link-recover-account" action="PASSWORD_RECOVER">
          {t('Forgot your password?')}
        </Link>
      </PasswordField>

      {children}

      <div className="login-button-wrapper">
        <button id="btn-login" form="form-login" className="button btn-active" disabled={buttonsDisabled} type="submit">
          {t('Continue')}
        </button>
      </div>
    </form>
  ),
);
